import React, { useEffect, useState } from "react";
import Header from "../components/Header";
import "./Converter.css";

function Converter() {
  const [inputRomajiValue, setInputRomajiValue] = useState("");
  const [inputHiraganaValue, setInputHiraganaValue] = useState("");
  const [hiraganaData, setHiraganaData] = useState(null);

  useEffect(() => {
    const fetchAndDisplayHiragana = async () => {
      try {
        const response = await fetch("/db/db.json");
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        setHiraganaData({
          ...data.hiragana.seriesException,
          ...data.hiragana.seriesVowel,
          ...data.hiragana.seriesK,
          ...data.hiragana.seriesS,
          ...data.hiragana.seriesT,
          ...data.hiragana.seriesN,
          ...data.hiragana.seriesH,
          ...data.hiragana.seriesM,
          ...data.hiragana.seriesY,
          ...data.hiragana.seriesR,
          ...data.hiragana.seriesW,
          ...data.dakuten.seriesG,
          ...data.dakuten.seriesZ,
          ...data.dakuten.seriesD,
          ...data.dakuten.seriesB,
          ...data.dakuten.seriesP,
          ...data.yoon.seriesK,
          ...data.yoon.seriesS,
          ...data.yoon.seriesT,
          ...data.yoon.seriesN,
          ...data.yoon.seriesH,
          ...data.yoon.seriesM,
          ...data.yoon.seriesR,
          ...data.yoon.seriesG,
          ...data.yoon.seriesZ,
          ...data.yoon.seriesD,
          ...data.yoon.seriesB,
          ...data.yoon.seriesP,
        });
      } catch (error) {
        console.error("Error fetching or displaying data:", error);
      }
    };
    fetchAndDisplayHiragana();
  }, []);

  const handleInputRomajiChange = (e) => {
    const value = e.target.value;
    setInputRomajiValue(value);

    if (hiraganaData && value) {
      let result = "";
      let i = 0;

      while (i < value.length) {
        // try matching 3 chars first, then 2, then 1
        const three = value.slice(i, i + 3).toLowerCase();
        const two = value.slice(i, i + 2).toLowerCase();
        const one = value.slice(i, i + 1).toLowerCase();

        if (hiraganaData[three]) {
          result += hiraganaData[three].hiragana;
          i += 3;
        } else if (hiraganaData[two]) {
          result += hiraganaData[two].hiragana;
          i += 2;
        } else if (hiraganaData[one]) {
          result += hiraganaData[one].hiragana;
          i += 1;
        } else {
          result += value[i]; // no match, keep original character
          i += 1;
        }
      }

      setInputHiraganaValue(result);
    } else {
      setInputHiraganaValue("");
    }
  };

  const handleInputHiraganaChange = (e) => {
    const value = e.target.value;
    setInputHiraganaValue(value);
    if (hiraganaData && value) {
      const hiraganaArray = value.trim().split("");
      const romajiArray = hiraganaArray.map((hiragana) => {
        const found = Object.entries(hiraganaData).find(
          ([key, val]) => val.hiragana === hiragana,
        );
        return found ? found[0].toLowerCase() : hiragana;
      });
      setInputRomajiValue(romajiArray.join(" "));
    } else {
      setInputRomajiValue("");
    }
  };

  return (
    <div>
      <Header />
      <div className="contContainer">
        <h1 className="converterDisplay">
          Skriv in rōmaji eller hiragana för att omvandla.
        </h1>
        <div className="converterBox">
          <form id="inputDisplay">
            <textarea
              placeholder="Romaji"
              value={inputRomajiValue}
              onChange={handleInputRomajiChange}
            />
          </form>
          <form id="inputDisplay">
            <textarea
              placeholder="Hiragana"
              value={inputHiraganaValue}
              onChange={handleInputHiraganaChange}
            />
          </form>
        </div>
      </div>
    </div>
  );
}

export default Converter;
